<template>
  <div class="lay-overtime">
    <mt-cell title="出勤天数" :value="(signNum || 0)+'天'"></mt-cell>
    <mt-cell title="迟到" :value="(lateNum || 0)+'次'"></mt-cell>
    <mt-cell title="早退" :value="(earlyNum || 0)+'次'"></mt-cell>
    <mt-cell title="缺卡" :value="(lackNum || 0)+'次'"></mt-cell>
  </div>
</template>

<script>
export default {
  props: [
    'signNum',
    'lateNum',
    'lackNum',
    'earlyNum'
  ]

}
</script>

<style lang="scss">
  .lay-overtime {
    border-bottom: 10px solid #f2f2f2;
    .mint-cell {
      &:last-child{
        background-size: 100% 0;
      }
    }
    .mint-cell-wrapper {
      background-size: 100% 1px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/layOvertime.vue